<template>
    <div>
        <app-header></app-header>
        <main id="page-main" class="with-tabs">
            <nav>
                <ul>
                    <li><router-link :to="{ name: 'config' }"><i class="icon icon-icon_home"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('config.attribute')>=0"><router-link :to="{ name: 'attribute' }"><i class="icon icon-icon_layers"></i> Attributes</router-link></li>
                    <li v-if="$store.state.modules.indexOf('config.scope')>=0"><router-link :to="{ name: 'scope' }"><i class="icon icon-icon_layers"></i> Scopes</router-link></li>
                </ul>
            </nav>
            <router-view></router-view>
        </main>
    </div>
</template>
<script>
    export default {
        data () {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/Index.vue